export class ReferanceAirline {
  constructor() {
    this.iata = '';
    this.icao = '';
    this.name = [null, null];
    this.code = [null, null];
    this.weightAdult = [null, null];
    this.weightChild = [null, null];
    this.weightInfant = [null, null];
    this.international = false;
    this.countryId = null;
    this.dtRange = [null, null];
    this.lastupdate = undefined;
  }

  id: number;
  iata: string;
  icao: string;
  code: Array<string>;
  name: Array<string>;
  private weightAdult: Array<number>;
  private weightChild: Array<number>;
  private weightInfant: Array<number>;
  international: boolean;
  countryId: number;
  countryIata: string;
  countryIcao: string;
  countryName: Array<string>;
  private dtRange: Array<Date>;
  lastupdate: string;

  /**
   * Функции чтения/записи времени актуальности записи
   */

  get dtRangeStart(): Date {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0]!==null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1]!==null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date) {
    this.dtRange[1] = value;
  }

  /**
   * Функции чтения/записи наименований авиакомпании
   * на английском и локальном языке
   */

  get nameEnglish(): string {
    if ((this.name) && (this.name.length >= 1)) {
      return this.name[0];
    } else {
      return null;
    }
  }

  set nameEnglish(value: string) {
    this.name[0] = value;
  }

  get nameLocal(): string {
    if ((this.name) && (this.name.length === 2)) {
      return this.name[1];
    } else {
      return null;
    }
  }

  set nameLocal(value: string) {
    this.name[1] = value;
  }

  /**
   * Функция вывода наименований авиакомпании в строку
   */
  get names(): string {
    if ((this.name) && (this.name.length > 0)) {
      return this.name.join('/');
    } else {
      return null;
    }
  }
  /**
   * Функции чтения/записи кодов 
   * на английском и локальном языке
   */

  get codeEnglish(): string {
    if ((this.code) && (this.code.length >= 1)) {
      return this.code[0];
    } else {
      return null;
    }
  }

  set codeEnglish(value: string) {
    this.code[0] = value;
  }

  get codeLocal(): string {
    if ((this.code) && (this.code.length === 2)) {
      return this.code[1];
    } else {
      return null;
    }
  }

  set codeLocal(value: string) {
    this.code[1] = value;
  }

  /**
   * Функции чтения/записи данных о среднем весе
   * взрослых/детей/новорожденных пассажиров
   * в летнее/зимнее время
   */

  // Взрослые пассажиры
  get weightAdultWinter(): number {
    if ((this.weightAdult) && (this.weightAdult.length >= 1)) {
      return this.weightAdult[0];
    } else {
      return null;
    }
  }

  set weightAdultWinter(value: number) {
    this.weightAdult[0] = value;
  }

  get weightAdultSummer(): number {
    if ((this.weightAdult) && (this.weightAdult.length === 2)) {
      return this.weightAdult[1];
    } else {
      return null;
    }
  }

  set weightAdultSummer(value: number) {
    this.weightAdult[1] = value;
  }

  // Дети пассажиры
  get weightChildWinter(): number {
    if ((this.weightChild) && (this.weightChild.length >= 1)) {
      return this.weightChild[0];
    } else {
      return null;
    }
  }

  set weightChildWinter(value: number) {
    this.weightChild[0] = value;
  }

  get weightChildSummer(): number {
    if ((this.weightChild) && (this.weightChild.length === 2)) {
      return this.weightChild[1];
    } else {
      return null;
    }
  }

  set weightChildSummer(value: number) {
    this.weightChild[1] = value;
  }

  // Новорожденные пассажиры
  get weightInfantWinter(): number {
    if ((this.weightInfant) && (this.weightInfant.length >= 1)) {
      return this.weightInfant[0];
    } else {
      return null;
    }
  }

  set weightInfantWinter(value: number) {
    this.weightInfant[0] = value;
  }

  get weightInfantSummer(): number {
    if ((this.weightInfant) && (this.weightInfant.length === 2)) {
      return this.weightInfant[1];
    } else {
      return null;
    }
  }

  set weightInfantSummer(value: number) {
    this.weightInfant[1] = value;
  }
}
